// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__N4Fij","heading":"styles_heading__weeL4","pageHeadingContainer":"styles_pageHeadingContainer__5bG54","backButton":"styles_backButton__So8mJ"};